export default "__VITE_ASSET__04aa7f9c__"